/**
 * Stats/Metrics data for Home page
 * Icons imported dynamically to avoid bundle bloat
 */
import GroupsIcon from "@mui/icons-material/Groups";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";

export const getStats = (t) => [
  {
    icon: <GroupsIcon sx={{ fontSize: 44 }} />,
    value: "10+",
    label: t("home.stats.clients"),
  },
  {
    icon: <CheckCircleIcon sx={{ fontSize: 44 }} />,
    value: "15+",
    label: t("home.stats.projects"),
  },
  {
    icon: <TrendingUpIcon sx={{ fontSize: 44 }} />,
    value: "8+",
    label: t("home.stats.experience"),
  },
  {
    icon: <EmojiEventsIcon sx={{ fontSize: 44 }} />,
    value: "98%",
    label: t("home.stats.satisfaction"),
  },
];
